import type { TeamCategoryFilter } from '@travel-planner/shared/schemas';
import { teamCategoryFilterValues } from '@travel-planner/shared/schemas';

export type TeamsSearch = {
  countryId?: string;
  search?: string;
  page?: number;
  teamCategory?: TeamCategoryFilter;
};

const isUuid = (v: unknown): v is string =>
  typeof v === 'string' &&
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(v);

const asString = (v: unknown): string | undefined =>
  typeof v === 'string' && v.length > 0 ? v : undefined;

const TEAM_CATEGORY_FILTER_SET = new Set<string>(teamCategoryFilterValues);

const asTeamCategoryFilter = (v: unknown): TeamCategoryFilter | undefined =>
  typeof v === 'string' && TEAM_CATEGORY_FILTER_SET.has(v)
    ? (v as TeamCategoryFilter)
    : undefined;

const asPage = (v: unknown): number | undefined => {
  if (typeof v === 'number' && Number.isInteger(v) && v >= 1) return v;
  if (typeof v === 'string' && /^\d+$/.test(v)) {
    const n = Number.parseInt(v, 10);
    return n >= 1 ? n : undefined;
  }
  return undefined;
};

export const validateTeamsSearch = (
  input: Record<string, unknown>
): TeamsSearch => ({
  countryId: isUuid(input.countryId) ? input.countryId : undefined,
  search: asString(input.search),
  page: asPage(input.page),
  teamCategory: asTeamCategoryFilter(input.teamCategory),
});
